export default {
    dialog: {
        msgShow: "訊息提示",
        buttonOk: '確定',
        buttonCancel: '取消',
    },
    photoBrowser: {
        bannerPhotoBrowser: '關閉'
    },
    employeeNumber: '員工編號',
    pleaseEnterEmployeeNumber: '請輸入員工編號',
    password: '密碼',
    pleaseEnterPassword: '請輸入密碼',
    login: '登入',
    required: '必填',
    synchronize: '同步',
    salesOrder: '售服單',
    pleaseEnterHome: '請輸入客戶名稱、售服單號、機號',
    searchFilter: '搜尋篩選',
    machineSpecifications: '機種規格',
    processingStatus: '處理狀態',
    processing: '處理中',
    finish: '完成',
    waitCountermeasures: '待對策',
    reset: '重設',
    submit: '送出',
    muMachineInvestigation: 'MU機台調查',
    logout: '登出',
    searchDate: '搜尋日期',
    time: '時間',
    basicInformation: '客戶資訊',
    addSalesOrder: '新增售服單',
    save: '儲存',
    date: '日期',
    pleaseSelectDate: '請選擇日期',
    travelNumber: '出差單號',
    pleaseEnterTravelNumber: '請輸入出差單號',
    customerCode: '客戶代號',
    pleaseEnterCustomerCode: '請輸入客戶代號',
    customerName: '客戶名稱',
    pleaseEnterCustomerName: '請輸入客戶名稱',
    country: '國別',
    pleaseEnterCountry: '請輸入國別',
    customerAddress: '客戶地址',
    pleaseEnterAddress: '請輸入客戶地址',
    customerContact: '客戶聯絡人',
    pleaseEnterContact: '請輸入客戶聯絡人',
    salesRepresentative: '業務代表',
    pleaseEnterSalesRepresentative: '請輸入業務代表',
    hint: '提示',
    createDate: '建立日期',
    salesOrderNumber: '售服單號',
    customerSatisfaction: '客戶滿意度',
    maintenancePersonnel: '維修人員',
    maintenanceTime: '維修時間',
    customerConfirmation: '客戶確認',
    copy: '複製',
    delete: '刪除',
    recordTime: '紀錄時間',
    machineNumber: '機號',
    copyToSalesOrder: '複製至此售服單',
    copyTo: '複製到',
    selectSalesOrderNumber: '選擇售服單號',
    pleaseEnterSalesOrderNumber: '請輸入售服單號',
    latitudeAndLongitude: '經緯度',
    startMaintenance: '開始維修',
    endMaintenance: '結束維修',
    newMachine: '新裝機',
    maintenance: '維修',
    addMachineServiceOrder: '新增機台服務單',
    selectType: '選擇類型',
    generalMaintenance: '一般維修',
    oilEducationTraining: 'OIL教育訓練',
    pleaseEnterMachineNumber: '請輸入機號',
    manufacturingDate: '製造日期(保固內需填寫，已過保固期不需填寫)',
    pleaseSelectManufacturingDate: '請選擇製造日期',
    maintenanceWarranty: '維修保固(一年內)',
    underWarranty: '保固內',
    warrantyExpired: '已過保固期',
    confirm: '確認',
    cancel: '取消',
    addMaintenancePersonnel: '新增維修人員',
    maintenanceTimeTotal: '維修時間總計',
    day: '天',
    hour: '小時',
    enterFactory: '進場',
    pleaseSelectEnterFactory: '請選擇進場',
    longitude: '經度',
    // pleaseEnterLongitude: '請輸入經度',
    latitude: '緯度',
    // pleaseEnterLatitude: '請輸入緯度',
    leaveFactory: '出場',
    pleaseSelectLeaveFactory: '請選擇出場',
    duration: '時長',
    pleaseEnter: '請輸入',
    selectTime: '選擇時間',
    selectSatisfaction: '選擇滿意度',
    verySatisfied: '非常滿意',
    satisfied: '滿意',
    ordinary: '普通',
    dissatisfied: '不滿意',
    veryDissatisfied: '非常不滿意',
    opinionReply: '意見回覆',
    takePhoto: '照相',
    uploadFile: '上傳檔案',
    audio: '音檔',
    video: '影片',
    electronicSignature: '電子簽名',
    signatureDate: '簽名日期',
    clear: '清除',
    machineInformation: '機台資訊',
    machineFunction: '機台功能',
    organizationArrangement: '組織排列',
    spareParts: '零配件',
    operationProcedure: '其他紀錄',
    problemHandling: '問題處理',
    trainee: '受訓對象',
    coursePlan: '課程計畫',
    courseSchedule: '課程時程',
    inputVoltageAndCurrent: '輸入電壓/電流',
    lowSpeed: '低速',
    highSpeed: '高速',
    accelerationDecelerationSlope: '加減速斜率',
    acceleration: '加速',
    deceleration: '減速',
    clothRoller: '捲布',
    left: '左',
    center: '中',
    right: '右',
    yarnFeedingTeeth: '送紗齒/盤',
    saddleRingDistance: '上、下筒位置',
    yarnNozzleNumber: '紗嘴位置',
    height: '高度',
    spacing: '間距',
    warpYarnInfo: '胚布資訊',
    inch: '英寸',
    cm: 'CM公分',
    timeSequence: '時序',
    needle: '針',
    yarnSpecification: '紗線規格',
    yarn: '紗線',
    serialNumber: '連號',
    technician: '技術員',
    series: '系列',
    fabricType: '布種',
    productFeatures: '產品特性',
    inputVoltage: '輸入電壓',
    inputCurrent: '輸入電流',
    electronicWindingTensionUpper: '電子式捲布張力上',
    electronicWindingTensionLower: '電子式捲布張力下',
    mechanicalType: '機械式 捲布齒輪位置',
    lowerNeedleDistanceToSeatRing: '下針筒距離鞍座圈',
    upperNeedleDistanceToSeatRing: '上針筒距離鞍座圈',
    upperNeedleDistanceToLowerNeedleNozzle: '上針筒距離下針筒嘴口',
    selectorNeedleRingDistanceToTakeUpPlate: '選針座圈距離大盤',
    seatRingDistanceToTakeUpPlate: '鞍座圈距離大盤',
    machineSpeed: '機台轉速',
    inverterFrequency: '變頻器頻率',
    yarnCount: '目數',
    gramsPerSquareMeter: '米平方重',
    yardsPerPound: '碼重',
    customerYarnWidth: '幅寬',
    customerSpecifiedYarnLength: '客指紗長',
    newCustomerPackageTiming: '新客盤時序',
    doubleSidedCuttingTiming: '雙面切盤時序',
    nozzleTiming: '紗嘴時序',
    yarnCode: '紗線代號',
    yarnType: '紗線種類',
    color: '顏色',
    yarnSize: '紗支粗細',
    fiberCount: '纖維數',
    innerFiber: '內毛',
    outerFiber: '外毛',
    flatness: '平度',
    roundness: '圓度',
    windPressure: '風壓',
    appearance: '外觀',
    machineLevel: '機台水平',
    trident: '三叉',
    highLegWinder: '高腳捲布機',
    fabricSlitting: '剖布捲布機',
    inverterCurrent: '變頻器電流',
    machineFunctionFrame: '機架, 紗架安裝與功能',
    inchStart: '吋啟動,停止開關功能',
    firstSecondSpeed: '一二速 上/下燈 風扇開關功能',
    firstSecondSpeed2: '一二速 寸 清車各速度功能',
    controllerOtherFunctions: '控制器其他功能',
    electricalBoxSignals: '電器盒訊號',
    fanDustRemovalAction: '風扇除塵動作',
    oilSprayerAction: '噴油機動作',
    airBlowerSystemAction: '噴風系統動作',
    windingAction: '捲布動作',
    machineControllerOperationTutorial: '機台控制器操作使用教學',
    machineOperationTutorial: '機台操作使用教學',
    other: '其他',
    descriptionAndAttachment: '說明及附件',
    upperNeedleArrangement: '上針排列',
    upperKnifeArrangement: '上刀排列',
    lowerNeedleArrangement: '下針排列',
    lowerNeedleArrangementShort: '下針排列',
    lowerKnifeArrangement: '下刀排列',
    lowerKnifeArrangementShort: '下刀排列',
    upperNeedlePlate: '上針盤',
    lowerNeedleCylinder: '下針筒',
    blank: '空白',
    blockRule: '塊規',
    retractionBaseline: '退基準',
    upperPlateNeedleWithdrawalKnob: '上盤收針旋鈕',
    upperPlateNeedleWithdrawalDepth: '上盤收針深度',
    upperPlateHalfNeedleHeight: '上盤出半針高度',
    upperPlateFlatNeedleHeight: '上盤平針高度',
    lowerCylinderFlatNeedleHeight: '下筒平針高度',
    lowerCylinderFlatNeedleDepth: '下筒收針深度',
    lowerCylinderNeedleWithdrawalKnob: '下筒收針旋鈕',
    yarnTypeCode: '紗種代碼',
    yarnTypeTensionN: '紗種張力N',
    cmPer100Needles: 'cm/100支針',
    feedYarnLengthPerRevolution: '喂紗長/1圈',
    aluminumPlateYarnFeedingDepthCm: '鋁盤送紗深度cm',
    yarnFeedingAluminumPlateScale: '送紗鋁盤刻度',
    newCustomerPackage: '新克片',
    upperPlate: '上盤',
    lowerCylinder: '下筒',
    yarnShort: '紗',
    pleaseEnterProductName: '請輸入品名',
    pleaseEnterProductNumber: '請輸入品號',
    quantity: '數量',
    damage: '損毀',
    missing: '缺漏',
    wrong: '錯件',
    pleaseEnterTitle: '請輸入標題',
    pleaseEnterContent: '請輸入內容',
    addQuestionItem: '新增問題項目',
    questionProcessingRecord: '問題處理紀錄',
    pleaseEnterQuestionDescription: '請輸入問題說明',
    traineeAndClient: '受訓者/客戶',
    trainer: '訓練者',
    drawingFunction: '繪圖功能',
    upperMachineProgram: '上機程序',
    UnravelingFunction: '解織功能',
    courseName: '課程名稱',
    pleaseEnterCourseName: '請輸入課程名稱',
    imageName: '圖檔名稱',
    pleaseEnterImageName: '請輸入圖檔名稱',
    confirmItem: '確認事項',
    undone: '未完成',
    pleaseEnterInquire: '請輸入客戶名稱、調查單號',
    machineUtilizationSurvey: '機台使用率調查表',
    customerID: '客戶ID',
    pleaseEnterCustomerID: '請輸入客戶ID',
    pleaseSelect: '請選擇',
    pleaseEnterSkill: '請輸入Skill',
    pleaseEnterBuyer: '請輸入Buyer',
    pleaseEnterRemark: '請輸入Remark',
    source: '來源',
    selfInput: '自行輸入',
    textileEquipment: '紡織設備',
    textileMachineBrand: '紡織機廠牌',
    textileMachineType: '紡織機類型',
    notSelected: '未選擇',
    select: '選取',
    brand: '廠牌',
    totalMachine: '總台數',
    openRate: '開機率(%)',
    dailyOutput: '日產量(T)',
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: '請輸入處理內容',
    // alert
    editNotSave: '編輯尚未儲存，確定要退出嗎？',
    deleteConfirm: '是否確認刪除？',
    confirmClearSignature: '是否確認清除簽名相關資料？',
    confirmWriteData: '確認寫入資料？',
    confirmCopyToSalesOrder: '確認複製至此售服單？',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: '刪除成功。',
    clearSuccess: '清除成功。',
    copySuccess: '複製完成。',
    selectWorker: '請先選擇維修人員',
    selectProblem: '請先選擇問題項目',
    unknownError: '發生未知錯誤，請洽詢客服',
    fileTypeError: '檔案類型不符',
    openCameraPermission: '請先開啟相機權限',
    //new
    selectDate: '選擇日期',
    yarnTensionN: '紗張力N',
    category: '分類',
    kind: '種類',
    // pleaseSelectType: '請選擇類型',
    dateInOutError: '出場日期不得小於進場日期',
    yarnFeedingTeethOrDisc: '送紗齒/盤',
    changed: '已更換',
    pleaseSelectSparePartsStatus: '請選擇零配件狀態',
    pleaseEnterDuration: '請輸入時長',

    // API語系
    saveComplete: '儲存成功。',
    needOnline: '需要連線',
    addComplete: '新增成功。',
    reportCreator: '建立人員',
    onlineGenerate: '上傳後生成',
    synchronizeFail: '同步異常',
    synchronizeSuccess: '同步成功',
    downloadFail: '下載異常',
    downloadSuccess: '下載成功',
    synchronizeSelect: '同步選擇',
    onlySynchronizeOffData: '下載線上資料',
    synchronizeData: '離線資料同步',
    synchronizeImage: '同步圖片',
    downloadOfflineFile: '下載離線檔案',
    downloadOfflineData: '下載離線資料',
    downloadOfflineImage: '下載離線圖片',
    synchronizing: '同步中，請勿關閉應用程式畫面',
    downloading: '下載中，請勿關閉應用程式畫面',
    confirmDownload: '是否確認下載？',
    confirmSynchronization: '是否確認同步？',
    overwriteOffline : '將覆蓋目前的離線資料',
    synchronizationOnline: '將同步線上相關資料',
    uploadFail: '上傳異常',
    fileSzieOverTit: '檔案容量過大',
    fileSzieOverMes: '僅能上傳50MB以下的檔案，超過50MB請至有線版上傳',

    sortByCreate: '依建立順序排列',
    sortByType: '依服務單類型排列',
    reportDownload: '機台服務單明細下載',
    selectServiceReport: '選擇服務單',
    enterServiceReportOrMachine: '輸入服務單號、機號',
    selectAll: '全選',

    downloadHint:"背景執行下載中，請勿重複點選送出。"

}
